export enum RequestFormType {
    FORM        = 1,            // public FORM  'form'
    REQUEST     = 2             // 'request' - INTERNAL REQUEST
}

export enum RequestFormFieldType {
    TASK    = 'task', // both system and custom ?
    FORM    = 'form'
}